<template>
  <v-btn
    rounded
    small
    color="error"
    min-width="115"
    @click="removerAnexo()"
  >
    <v-icon size="17" class="mr-2">mdi-delete</v-icon> Remover</v-btn
  >
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    anexo: Object,
  },
  computed: mapState("anexos", ["docs"]),
  methods: {
    removerAnexo() {
      var index = this.docs.findIndex((doc) => doc.codanexo == this.anexo.codigo);

      if (index >= 0) {
        this.docs.splice(index, 1);
      }
    },
  },
};
</script>

<style>
</style>